/* eslint-disable react/jsx-props-no-spreading */
import { Menu } from "antd";
import { NavLink } from "react-router-dom";

const { SubMenu } = Menu;

const NavMenu = () => {
  return (
    <Menu
      style={{ width: "100%", minWidth: 240 }}
      defaultSelectedKeys={
        window.location.pathname === "/about-us/"
          ? ["1"]
          : window.location.pathname === "/about-us/members/"
          ? ["2"]
          : window.location.pathname === "/about-us/history/timeline/"
          ? ["3"]
          : window.location.pathname === "/about-us/history/detailed-history/"
          ? ["4"]
          : window.location.pathname === "/about-us/partners/"
          ? ["5"]
          : [""]
      }
      mode="inline"
    >
      <Menu.Item key="1">
        <NavLink exact to="/about-us/" activeStyle={{ color: "white" }}>
          Om oss
        </NavLink>
      </Menu.Item>
      <Menu.Item key="2">
        <NavLink to="/about-us/members/" activeStyle={{ color: "white" }}>
          Medlemmer
        </NavLink>
      </Menu.Item>
      <SubMenu key="sub1" title="Historie">
        <Menu.Item key="3">
          <NavLink to="/about-us/history/timeline/" activeStyle={{ color: "white" }}>
            Tidslinje
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/about-us/history/detailed-history/" activeStyle={{ color: "white" }}>
            Detaljert historie
          </NavLink>
        </Menu.Item>
      </SubMenu>
      <Menu.Item key="5">
        <NavLink to="/about-us/partners/" activeStyle={{ color: "white" }}>
          Samarbeidspartnere
        </NavLink>
      </Menu.Item>
    </Menu>
  );
};

export default NavMenu;
